import http from "../services/http";

export const apiGetPlans = async (params = {}) => {
  try {
    const response = await http.get("/api/doctor/plans", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiUpdatePlan = async (data = {}) => {
  try {
    const response = await http.put("/api/doctor/plans/update", data);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
